import Rest from '../Services/Rest'
import {store} from '../store/store'

/**
 * @typedef {ProductService}
 */
export default class ProductService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/product'

   /**
   * @param {Object} record
   * @returns {*|PromiseLike<T | never>|Promise<T | never>}
   */
  salvar (record) {    
    return this.post('/save', record)
  }

  salvarFormData(record){

    var form_data = new FormData();
    for ( var key in record ) {
      form_data.append(key, record[key]);
    }

    return this.postFormData('/save', form_data)
  }

  sendCover(record){
    var form_data = new FormData();
    for ( var key in record ) {
      form_data.append(key, record[key]);
    }
    return this.postFormData('/save/cover', form_data);
  }

  sendAudioFile(record, config_extras){
    var form_data = new FormData();
    for ( var key in record ) {
      form_data.append(key, record[key]);
    }
    let config = {headers: { 
        'Content-Type': 'multipart/form-data',
        'Authorization':'Bearer '+store.getters.token,
        'Access-Control-Allow-Origin': '*' 
      }
    };
    return this.postFormData('/save/audio', form_data, {...config, ...config_extras});
  }

  
   /**
   * @param {Object} record
   * @returns {*|PromiseLike<T | never>|Promise<T | never>}
   */
  getOne (id){

    return this.get(`/${id}`)    
  }

  searchProducts(param = ''){
    if(param == ''){
      return [];
    }

    return this.get(`/search?q=${param}`);
  }

  /**
   * @param {Object} parameters
   * @returns {*|PromiseLike<T | never>|Promise<T | never>}
   */
  search (parameters = {}) {
    var queryString = ''
   
    if( Object.keys(parameters).length ){
      var _p = [];
      
      Object.keys(parameters).map(function(key,index){
        _p.push( key+"="+parameters[key] );
      });
      queryString = "?"+ _p.join("&");
    }
    return this.get(`/all${queryString}`).then(response => ({
      items: response.items 
    }))
  }

}